import { detect } from 'detect-browser';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Transition } from 'react-transition-group';
import { UncontrolledAlert, Row, Col, Container } from 'reactstrap';

import Loading from 'shared/components/Loading';
import { selectActiveMaintenanceMessage } from 'shared/store/modules/systemMaintenanceMessage/selectors';
import 'react-toastify/dist/ReactToastify.css';

import styles from './Content.styles';
import sctheme from 'app/styles/sctheme';

const duration = 150;

const defaultStyles = {
  backgroundColor: sctheme.white,
  opacity: 0,
  visiblity: 'hidden'
};

const transitionStyles = {
  entering: {
    opacity: 0.75,
    visibility: 'visible'
  },
  entered: {
    opacity: 0.75,
    visibility: 'visible'
  },
  exiting: {
    opacity: 0.75,
    visibility: 'visible'
  },
  exited: {
    opacity: 0,
    visibility: 'hidden',
    transition: `all ${duration}ms linear`
  }
};

class ContentClass extends Component {
  constructor(props) {
    super(props);

    this.content = React.createRef();
    this.contentContainer = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (this.content.current && this.content.current.scrollTo) {
        this.content.current.scrollTo(0, 0);
      }
      if (this.contentContainer.current && this.contentContainer.current.scrollTo) {
        this.contentContainer.current.scrollTo(0, 0);
      }
    }
  }

  render() {
    const browser = detect();
    const location = this.props.location;
    const isCheckout = location.pathname.includes('checkout') || location.pathname.includes('confirmation');

    return (
      <>
        <main ref={this.content} css={styles}>
          <div
            className={`${Boolean(this.props.systemMaintenanceMessage) ? 'has-system-message' : ''} ${
              isCheckout ? '' : 'content'
            }`}
          >
            <div className="content-container" ref={this.contentContainer}>
              <ToastContainer />

              {browser.name === 'ie' && (
                <UncontrolledAlert className="mb-0" color="warning">
                  Your browser isn't fully supported at this time. Please consider using{' '}
                  <a href="https://www.google.com/chrome/">Chrome</a>,{' '}
                  <a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>, or{' '}
                  <a href="https://www.microsoft.com/en-us/windows/microsoft-edge">Edge</a>.
                </UncontrolledAlert>
              )}

              {this.props.children}

              {!isCheckout && (
                <div
                  className="copyright mt-auto"
                  style={this.props.systemMaintenanceMessage ? { marginBottom: '3rem' } : {}}
                >
                  <Container fluid>
                    <div className="copyright-inner text-muted">
                      <Row>
                        <Col>
                          <div className="d-flex justify-content-between flex-wrap">
                            <div className="p-3">
                              {!this.props.hidePoweredBySunCentral && (
                                <a href="https://www.suncentral.net" rel="noopener noreferrer" target="_blank">
                                  Powered by SunCentral
                                </a>
                              )}
                            </div>
                            <div className="d-flex">
                              <div className="p-3">
                                <Link target="_blank" to="/terms">
                                  Terms of Use
                                </Link>
                              </div>
                              <div className="p-3">
                                <Link target="_blank" to="/privacy">
                                  Privacy Policy
                                </Link>
                              </div>
                              <div className="p-3 ml-auto">
                                <Link target="_blank" to="/payment-terms">
                                  Payment Terms
                                </Link>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Container>
                </div>
              )}
            </div>

            <Transition in={this.props.loading} timeout={duration}>
              {state => (
                <div
                  className="loading-overlay"
                  style={{
                    ...defaultStyles,
                    ...transitionStyles[state]
                  }}
                >
                  <Loading />
                </div>
              )}
            </Transition>
          </div>
        </main>
      </>
    );
  }
}

const mapStateToProps = state => ({
  hidePoweredBySunCentral: state.features.hidePoweredBySunCentral,
  loading: state.admin.loading,
  provider: state.provider,
  systemMaintenanceMessage: selectActiveMaintenanceMessage(state)
});

const ContentWithRouter = props => {
  const location = useLocation();
  return <ContentClass {...props} location={location} />;
};

export default connect(mapStateToProps, null)(ContentWithRouter);
